import { i18n } from '@lingui/core';
export async function HandleChangeLang(lang) {
  const { messages } = await import(`../locales/${lang}.js`);
  i18n.load(lang, messages);
  i18n.activate(lang);
  localStorage.setItem('curLang', lang);
}
export function GetCurrentLanguage(){
  var curLang = localStorage.getItem('curLang');
  curLang = curLang == null ? 'en-US' : curLang;
  return curLang;
}
